import { render } from "./DisplayImageGallery.vue?vue&type=template&id=5ffc8b8d&scoped=true"
import script from "./DisplayImageGallery.vue?vue&type=script&lang=js"
export * from "./DisplayImageGallery.vue?vue&type=script&lang=js"

import "./DisplayImageGallery.vue?vue&type=style&index=0&id=5ffc8b8d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffc8b8d"]])

export default __exports__